// extracted by mini-css-extract-plugin
export default {"columnPhoto":"columns_columnPhoto__nuHT5","columnFIO":"columns_columnFIO__hcfC7","placeHolderShimmer":"columns_placeHolderShimmer__jJ+GS"};